module.exports = __webpack_public_path__ + "static/media/logo.47e962d4.png";